import { GetImagesApi } from "@/features/accounts/ocr/services/get-images-api";
import { GetImagesRequestModel } from "@/features/accounts/ocr/services/get-images-model";

/// OCR取込ファイル表示処理
export class GetImagesService {
  private getImagesApi = new GetImagesApi();

  /**
   * OCR取込ファイル表示API実行
   */
  public async GetImages(param: GetImagesRequestModel) {
    return await this.getImagesApi.GetImages(param);
  }
}
